import React from 'react';
import { Typography, Grid } from 'bonfire-kindling';
import { useTranslation } from 'react-i18next';
import { useApp } from 'providers/AppProvider';
import { utcToTimezone } from 'helpers/dates';

export default function DateGrid({
  DateOpen,
  DateClose,
  OpportunityIntentToBid,
  DateIntentToBidDue,
  OpportunityQAndA,
  DateQuestionsDue,
}) {
  const { t } = useTranslation();
  const { timezone } = useApp();

  return (
    <Typography variant="body3" sx={{ mt: { xs: 3, lg: 0 }, flexGrow: 1 }}>
      <Grid container spacing={1}>
        <Grid item xs={5} md={3}>
          <strong>{t('opportunities.project.open_date')}</strong>
        </Grid>
        <Grid item xs={7} md={3}>
          {utcToTimezone(DateOpen, { timezone })}
        </Grid>
        <Grid item xs={5} md={3}>
          <strong>{t('opportunities.project.close_date')}</strong>
        </Grid>
        <Grid item xs={7} md={3}>
          {utcToTimezone(DateClose, { timezone })}
        </Grid>
        {OpportunityIntentToBid && (
          <>
            <Grid item xs={5} md={3}>
              <strong>{t('opportunities.project.intent_to_bid_date')}</strong>
            </Grid>
            <Grid item xs={7} md={3}>
              {utcToTimezone(DateIntentToBidDue, { timezone })}
            </Grid>
          </>
        )}
        {OpportunityQAndA && (
          <>
            <Grid item xs={5} md={3}>
              <strong>{t('opportunities.project.questions_due_date')}</strong>
            </Grid>
            <Grid item xs={7} md={3}>
              {DateQuestionsDue ? utcToTimezone(DateQuestionsDue, { timezone }) : 'Never'}
            </Grid>
          </>
        )}
      </Grid>
    </Typography>
  );
}
